<template>
  <div class="classifyTree" @mouseleave="groupIndex = -1">
    <div class="title">工业用品分类</div>
    <div class="treeArea light-scrollbar">
      <div
        class="treeItem"
        v-for="(item, idx) in categoryList"
        :key="item.foregroundCategoryId"
        @mouseover="mouseoverGroup(idx)"
      >
        <div class="name cursor-pointer">
          <div class="ellipsis" @click.stop="jumpj(item.foregroundCategoryId)">
            {{ item.name }}
          </div>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="fiArea">
          <div
            v-for="(fi, findex) in item.children || []"
            :key="fi.foregroundCategoryId"
            class="fItem cursor-pointer"
          >
            <div class="ellipsis" @click.stop="jumpj(fi.foregroundCategoryId)">
              {{ fi.name }}
            </div>
            <span class="vline" v-if="findex < item.children.length - 1"
              >|</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="menu_right flex-grow" v-show="groupIndex > -1">
      <!-- 显示对应二级三级 -->
      <div class="menu_one_content flex-grow light-scrollbar">
        <div
          class="menu_two_row"
          v-for="(twoItem, twoIndex) in categoryList[groupIndex]
            ? categoryList[groupIndex].children || []
            : []"
          :key="twoItem.foregroundCategoryId"
        >
          <div
            class="two_menu_name cursor-pointer"
            @click.stop="jumpj(twoItem.foregroundCategoryId)"
          >
            {{ twoItem.name }}
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="three_menu">
            <span
              class="three_menu_name cursor-pointer"
              @click.stop="jumpj(threeItem.foregroundCategoryId)"
              v-for="threeItem in categoryList[groupIndex].children[twoIndex]
                .children || []"
              :key="threeItem.foregroundCategoryId"
              >{{ threeItem.name }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      categoryList: [], // 产品类目
      groupIndex: -1,
    };
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    // 产品分类行hover事件
    mouseoverGroup(idx) {
      console.log("mouseoverGroup");
      this.groupIndex = idx;
    },
    // 获取分类列表
    getCategoryList() {
      // 产品分类
      let httpUrl = "/front/cross/commodity-user/app/category-list";
      this.$http
        .get(httpUrl)
        .then(({ data: res }) => {
          console.log(res.data);
          this.categoryList = res.data.foregroundCategoryList || [];

          this.$store.commit(
            "setCategoryMenuList",
            res.data.foregroundCategoryList || []
          );
        })
        .catch(() => {});
    },
    jumpj(id) {
      let jumpName = "goodCategoryList";
      if (this.menuTypes === "selectionInquiry") {
        jumpName = "selectionCategoryList";
      }
      this.$router.push({
        name: jumpName,
        query: {
          foregroundCategoryId: id,
          brandIdList: "",
          seriesIdList: "",
          attributeValueIdList: "",
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
          category: true,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.classifyTree {
  font-family: Alibaba PuHuiTi;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0px 0px 2px 0px rgba(0, 18, 73, 0.2);
  width: 254px;
  position: relative;
  .treeArea {
    height: 320px;
    overflow: auto;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
    padding: 10px 16px;
    border-radius: 16px 16px 0 0;
    box-shadow: 0px 1px 1px 0px rgba(0, 18, 73, 0.2);
  }
  .treeItem {
    padding: 16px;
    border-bottom: #e1e3e6 solid 1px;
    .name {
      font-size: 16px;
      font-weight: bold;
      color: #1a1a1a;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      i {
        margin-left: 4px;
        margin-top: 2px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
  .fiArea {
    display: flex;
    flex-wrap: wrap;
    .fItem {
      flex-shrink: 0;
      display: inline-flex;
      max-width: 100%;
      &:hover {
        color: #2a54d1;
        opacity: 0.9;
      }
    }
    .vline {
      margin: 0 12px;
      font-size: 10px;
      color: #c8cacc;
      line-height: 2em;
    }
  }
  .menu_right {
    background-color: #fff;
    z-index: 11;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 700px;
    position: absolute;
    top: 0;
    left: 101%;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 2px 2px 5px 0px rgba(0, 18, 73, 0.2);
    overflow: hidden;
    .menu_one_row {
      width: 100%;
      height: 45px;
      background: #fff;
      border-bottom: 2px solid #f6f5fa;
      .menu_one_title {
        display: inline-block;
        color: #333;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        line-height: 42px;
        padding: 0px 20px;
        width: max-content;
      }

      .menu_one_title_choosed {
        background: #fff;
        color: #2a54d1;
      }
    }

    .menu_one_content {
      overflow-y: auto;

      .menu_two_row {
        padding: 0 30px;
        border-bottom: 2px solid #f6f5fa;
      }
      .two_menu_name {
        margin-top: 10px;
        line-height: 30px;
        font-size: 14px;
        font-weight: 500;
        color: #333;
        &:hover {
          color: #2a54d1;
          opacity: 0.9;
        }
      }

      .three_menu {
        font-size: 12px;
        font-weight: 400;
        color: #666;
        line-height: 25px;

        .three_menu_name {
          margin-right: 16px;
          &:hover {
            color: #2a54d1;
            opacity: 0.9;
          }
        }
      }
    }
  }
}
</style>
